<template>
  <v-form lazy-validation @submit.prevent="next">
    <div v-for="(question, i) in poll.questions" :key="i" id="question-id">
      <v-layout wrap row class="questions-size">
        <v-flex xs12 md8 lg8>
          <v-textarea
            v-model="question.question"
            :placeholder="$t('surveys.create_survey.write_your_question')"
            :prefix="i + 1 + '.'"
            hide-details
            rows="1"
            auto-grow
            clearable
            counter
            maxlength="220"
            :disabled="isLocked"
          />
        </v-flex>

        <div
          v-show="question.type != 'TEXT'"
          xs1
          md1
          lg1
          class="add-question-icon"
        >
          <v-tooltip bottom>
            <v-btn
              icon
              slot="activator"
              @click="addAnswer(question)"
              v-if="!isLocked"
            >
              <v-icon color="green">control_point</v-icon>
            </v-btn>
            <span>{{ $t('surveys.create_survey.add_question') }}</span>
          </v-tooltip>
        </div>
        <div
          xs1
          md1
          lg1
          class="add-question-icon"
          v-if="poll.questions.length !== 1"
        >
          <v-tooltip bottom>
            <v-btn
              icon
              slot="activator"
              @click="removeQuestion(i)"
              v-if="!isLocked"
            >
              <v-icon color="red">highlight_off</v-icon>
            </v-btn>
            <span>Eliminar pregunta</span>
          </v-tooltip>
        </div>
      </v-layout>
      <v-layout wrap row class="questions-size">
        <v-flex xs12 md8 lg8>
          <v-select
            :items="types.map((e) => ({ ...e, name: $t(e.langKey) }))"
            item-text="name"
            item-value="value"
            v-model="question.type"
            :placeholder="$t('surveys.create_survey.select_the_type')"
            required
            :disabled="isLocked || (isEdit && question.active)"
          />
        </v-flex>
      </v-layout>
      <div v-for="(answer, a) in question.answers" :key="a">
        <v-layout
          wrap
          row
          class="questions-size"
          v-show="question.type != 'TEXT'"
        >
          <v-flex xs12 md8 lg8 px-5>
            <v-textarea
              hide-details
              v-model="answer.answer"
              :placeholder="$t('surveys.create_survey.option') + (a + 1)"
              prepend-icon="panorama_fish_eye"
              :disabled="isLocked"
              rows="2"
              auto-grow
              clearable
              counter
              maxlength="220"
            />
          </v-flex>
          <v-flex xs1 md1 lg1 v-if="a > 1 && question.answers.length - 1 === a">
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click="removeAnswer(question, a)"
                v-if="!isLocked"
              >
                <v-icon color="red">highlight_off</v-icon>
              </v-btn>
              <span>Eliminar respuesta</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
      <br />
      <v-divider />
    </div>
    <desition
      @desition="$event ? onDeleteQuestion() : ''"
      v-model="modals.confirmDeleteQuestion"
      title="Eliminar pregunta"
      description="¿Está seguro que desea realizar dicha acción?. Este proceso es irreversible y no podrá recuperar la información"
    />
  </v-form>
</template>

<script>
import desition from '../../Dialogs/Confirm'

export default {
  components: {
    desition,
  },
  props: ['poll', 'isLocked', 'isEdit'],
  data: () => ({
    types: [
      {
        name: 'SIMPLE',
        value: 'SINGLE',
        langKey: 'surveys.create_survey.simple',
      },
      {
        name: 'MULTIPLE',
        value: 'MULTIPLE',
        langKey: 'surveys.create_survey.multiple',
      },
      {
        name: 'ABIERTA',
        value: 'TEXT',
        langKey: 'surveys.create_survey.open',
      },
    ],
    modals: {
      confirmDeleteQuestion: false,
    },
    questionToDeleted: '',
  }),
  methods: {
    removeQuestion(index) {
      this.questionToDeleted = index
      this.modals.confirmDeleteQuestion = true
    },
    onDeleteQuestion() {
      this.poll.questions.splice(this.questionToDeleted, 1)
      this.questionToDeleted = ''
    },
    removeAnswer(question, index) {
      question.answers.splice(index, 1)
    },
    addAnswer(question) {
      question.answers.push({ answer: '' })
    },
  },
}
</script>

<style>
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}

.questions-size .v-text-field {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.questions-size .v-input__slot {
  margin-bottom: 0 !important;
}

.questions-size .v-label {
  font-size: 14px !important;
}
.questions-size .v-input {
  font-size: 14px !important;
}

.questions-size .add-question-icon .v-btn {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>
<style scoped>
/deep/ .table-full .v-datatable.v-table > tbody {
  max-height: calc(100vh - 426px);
  min-height: calc(100vh - 426px);
}
</style>
